var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDiagonalFilled = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5H17.5857L3.29289 19.2928C2.90237 19.6833 2.90237 20.3164 3.29289 20.707C3.68342 21.0975 4.31658 21.0975 4.70711 20.707L19 6.41408V13C19 13.5523 19.4477 14 20 14C20.5523 14 21 13.5523 21 13V4C21 3.44772 20.5523 3 20 3H11Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDiagonalFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-diagonal-filled.7d03b011.svg";
export { ForwardRef as ReactComponent };